/**
 * Vuetify 1.x: sin `attach`, el menú se desprende al contenedor de la app y el cierre al
 * clic fuera puede fallar. Este mixin escucha el clic en document (fase burbuja), igual
 * que acaba recibiendo casi cualquier interacción que no haga stopPropagation hasta el final.
 *
 * El cierre se aplaza con setTimeout(0) para que el v-select termine de actualizar isMenuActive
 * en el mismo ciclo de clic y para alinearse con el patrón de v-click-outside de Vuetify.
 *
 * En cada vista: getVuetifyOutsideClickSelectRefs() → array de nombres de ref (Vue 2: refs
 * repetidas en v-for llegan como array).
 */
export default {
  mounted () {
    this.boundVuetifySelectOutsideClick = this.closeVuetifySelectsOnOutsideClick.bind(this)
    document.addEventListener('click', this.boundVuetifySelectOutsideClick, false)
  },

  beforeDestroy () {
    if (this._vuetifyOutsideClickTimer != null) {
      window.clearTimeout(this._vuetifyOutsideClickTimer)
      this._vuetifyOutsideClickTimer = null
    }
    if (this.boundVuetifySelectOutsideClick) {
      document.removeEventListener('click', this.boundVuetifySelectOutsideClick, false)
    }
  },

  methods: {
    closeVuetifySelectsOnOutsideClick (event) {
      if ('isTrusted' in event && event.isTrusted === false) {
        return
      }

      const clickTarget = event.target

      if (this._vuetifyOutsideClickTimer != null) {
        window.clearTimeout(this._vuetifyOutsideClickTimer)
      }

      this._vuetifyOutsideClickTimer = window.setTimeout(() => {
        this._vuetifyOutsideClickTimer = null

        const keys = typeof this.getVuetifyOutsideClickSelectRefs === 'function'
          ? this.getVuetifyOutsideClickSelectRefs()
          : []

        for (let k = 0; k < keys.length; k++) {
          const raw = this.$refs[keys[k]]
          const instances = raw == null ? [] : (Array.isArray(raw) ? raw : [raw])

          for (let i = 0; i < instances.length; i++) {
            const select = instances[i]
            if (!select || !select.isMenuActive) {
              continue
            }

            const rootEl = select.$el
            const menu = select.$refs.menu
            const content = menu && menu.$refs.content

            if (rootEl && rootEl.contains(clickTarget)) {
              continue
            }
            if (content && content.contains(clickTarget)) {
              continue
            }
            if (typeof select.blur === 'function') {
              select.blur(event)
            }
          }
        }
      }, 0)
    }
  }
}
